module.exports = __webpack_public_path__ + "static/img/04.46c23a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/04.png
// module id = 2kw+
// module chunks = 1